import { render } from "./ValidationPage.vue?vue&type=template&id=10bbfe0c&ts=true"
import script from "./ValidationPage.vue?vue&type=script&lang=ts"
export * from "./ValidationPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__